import { useEffect, useRef, useState } from 'react';
import QuoteWinSimple from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinSimple';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import { useProductDispatch, useProductState } from '../../ProductProvider';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/i18n';

const FreeQuote: React.FC = () => {
    const { t } = useLang('dpux.FreeQuote');
    const { locale } = getLocal();
    const [showIcon, setShowIcon] = useState(false);
    const { showFreeQuote } = useProductState();
    const dispatch = useProductDispatch();

    /** 动画 */
    const titleRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const callback = () => {
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            if (scrollY > 10) {
                setShowIcon(true);
            }
            if (window.innerWidth < 768 && scrollY > 100) {
                if (!titleRef.current) return;
                clearTimeout(id);
                titleRef.current.style.opacity = '0';
                titleRef.current.style.pointerEvents = 'none';
            }
        };
        const id = setTimeout(callback, 6000);
        window.addEventListener('scroll', callback);
        return () => {
            if (typeof window === 'undefined') return;
            window.removeEventListener('scroll', callback);
            callback();
        };
    }, []);

    return (
        <>
            {showIcon && (
                <div
                    className={`FreeQuote ${css.section} GtmModuleData-btn-text`}
                    onClick={() => {
                        dispatch({ type: 'changeShowFreeQuote', payload: true });
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'floating_button',
                            button_name: t('title'),

                            __btn_id1: css.section,
                            __btn_id2: t('title'),
                        });
                    }}
                >
                    <div className="title" ref={titleRef}>
                        <span>{t('title')}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <path
                                d="M5.78088 11.2266L9.95764 8.23535L5.78088 5.24381L6.55725 4.15983L11.4908 7.69336C11.6655 7.81856 11.7692 8.02042 11.7692 8.23535C11.7691 8.45028 11.6656 8.65218 11.4908 8.77734L6.55725 12.3105L5.78088 11.2266Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                    <div className="action-button"></div>
                </div>
            )}
            {showFreeQuote &&
                (locale === 'us' ? (
                    <QuoteWinSimple callback={() => dispatch({ type: 'changeShowFreeQuote', payload: false })} />
                ) : (
                    <QuoteWin callback={() => dispatch({ type: 'changeShowFreeQuote', payload: false })} />
                ))}
        </>
    );
};

export default FreeQuote;
